import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CatPaymentFrequencyModel } from 'src/app/model/cat-payment-frecuency.model';

@Injectable({
  providedIn: 'root'
})
export class CatPaymentFrequencyService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  //
  catalog=()=> {
    return this.http.get(`${this.url}/CatCommissionPaymentFrequency/Catalog`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAll=()=> {
    return this.http.get(`${this.url}/CatCommissionPaymentFrequency/list`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAllActive=()=> {
    return this.http.get(`${this.url}/CatCommissionPaymentFrequency/list`)
      .pipe(
        map((resp:any)=> resp.data.filter(freq=> freq.activeId))
      );
  }

  
  save=(frequency:CatPaymentFrequencyModel)=> {
    return this.http.post(`${this.url}/CatCommissionPaymentFrequency/SaveUpdate`, frequency)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  update=(frequency:CatPaymentFrequencyModel)=> {
    return this.http.post(`${this.url}/CatCommissionPaymentFrequency/SaveUpdate/${frequency.comnPayFreqId}`, frequency)
      .pipe(
        map((resp:any)=> resp)
      );
  }
}
